<script>
const LABEL_GROUPS = [
  {
    group: "review_screens_labels",
    title: "Review Screen Labels",
    subtitle: "Change the labels that display for contacts when they are reviewing a proof.",
    sections: [
      {
        title: "All Review Screens",
        fields: [
          { key: "approve_btn", label: 'The button text for "Approved"' },
          { key: "not_approved_btn", label: 'The button text for "Not Approved"' },
          { key: "approve_with_changes_btn", label: 'The button text for "Approve With Changes"' },
          { key: "submit_decision_btn", label: 'The button text for "Submit Decision"' },
          { key: "go_to_latest_version", label: 'The button text for "Go to Latest Version" (shown while viewing a previous version)' },
        ],
      },
    ],
  },
  {
    group: "approver_decision_modal_labels",
    title: "Approver Decision Modal Labels",
    subtitle: "Change the labels that display for approvers when they are approving or rejecting a proof.",
    sections: [
      {
        title: "Headers",
        fields: [
          { key: "approve_modal", label: "The header text that displays when an approver is about to approve a proof" },
          { key: "reject_modal", label: "The header text that displays when an approver is about to reject a proof" },
          { key: "approve_with_changes", label: "The header text that displays when an approver is about to approve with changes" },
          { key: "submit_decision_header", label: "The header text that displays when an approver is about to submit a decision" },
        ],
      },
      {
        title: "Instructions",
        fields: [
          { key: "feedback_box", label: "The instruction text that displays above the feedback box" },
          { key: "approver_acknowledge_checklist", label: "The instruction text that displays when an approver must acknowledge your checklist" },
          { key: "approve_individual_file", label: "The instruction text that displays when an approver must approve each file individually" },
        ],
      },
    ],
  },
  {
    group: "identify_yourself_modal_labels",
    title: "Please Identify Yourself Modal",
    subtitle: "Change the labels that display for contacts when they are registering to a proof.",
    sections: [
      {
        title: "",
        fields: [
          { key: "identify_yourself_header", label: "The header text that displays when a contact is registering" },
          { key: "identify_yourself_before_proofing", label: "The instruction text that displays when a contact is registering" },
          { key: "begin_review_btn", label: "The button text that displays when a contact is registering" },
        ],
      },
    ],
  },
];

export default {
  name: "accountLabels",
  data() {
    return {
      user: this.$A.Auth,
      languages: ['en-us', 'es-us'],
      labelGroups: LABEL_GROUPS,
      labels: {
        review_screens_labels: {
          approve_btn: {},
          not_approved_btn: {},
          approve_with_changes_btn: {},
          submit_decision_btn: {},
          go_to_latest_version: {},
        },
        approver_decision_modal_labels: {
          approve_modal: {},
          reject_modal: {},
          approve_with_changes: {},
          submit_decision_header: {},
          feedback_box: {},
          approver_acknowledge_checklist: {},
          approve_individual_file: {}
        },
        identify_yourself_modal_labels: {
          identify_yourself_header: {},
          identify_yourself_before_proofing: {},
          begin_review_btn: {}
        },
        contact_email_labels: {
          review_now: {}
        }
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    loadLanguages: async function() {
      for (const lang of this.languages) {
        const accountId = _.get(this, 'user.accountId', 0);
        accountId > 0 && await this.$A.LangService.loadLanguage(accountId, lang);
      }
    },
    loadLabels: async function () {
      let self = this;
      await self.loadLanguages();
      Object.keys(self.labels).forEach(group => {
        Object.keys(self.labels[group]).forEach(key => {
          self.languages.forEach(lang => {
            self.labels[group][key][lang] = self.$A.LangService.getLabel(group, key, lang);
          })
        })
      })
      this.$forceUpdate();
    },
    saveLabels: async function (group) {
      let self = this;
      let langEntries = [];
      Object.keys(self.labels[group]).forEach(key => {
        Object.keys(self.labels[group][key]).forEach(lang => {
          langEntries.push({key: key, language: lang, value: self.labels[group][key][lang]});
        })
      })
      await this.$A.LangService.saveLanguage(langEntries);
    }
  },
  mounted() {
    this.loadLabels();
  },
};
</script>


<template>
  <div class="labels-stack">
    <div class="settings-card" v-for="groupDef in labelGroups" :key="groupDef.group">
      <div class="card-head">
        <div class="card-head-title">{{ groupDef.title }}</div>
        <div class="card-head-subtitle">{{ groupDef.subtitle }}</div>
      </div>
      <div class="card-body">
        <div v-for="(section, sIndex) in groupDef.sections" :key="sIndex" class="label-section">
          <div v-if="section.title" class="section-title">{{ section.title }}</div>
          <div class="label-grid">
            <div class="label-field" v-for="field in section.fields" :key="field.key">
              <label class="field-label">{{ field.label }}</label>
              <div class="lang-row">
                <span class="lang-chip">EN</span>
                <input
                    type="text"
                    class="text-input"
                    v-model="labels[groupDef.group][field.key]['en-us']"
                />
              </div>
              <div class="lang-row">
                <span class="lang-chip">ES</span>
                <input
                    type="text"
                    class="text-input"
                    v-model="labels[groupDef.group][field.key]['es-us']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-foot">
        <b-button class="primary-btn" @click="saveLabels(groupDef.group)">Save</b-button>
      </div>
    </div>
  </div>
</template>


<style scoped>
.labels-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.section-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}
.label-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 20px;
}
.label-field {
  min-width: 0;
}
.field-label {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  color: #4b5563;
  line-height: 1.5;
  margin-bottom: 6px;
}
.lang-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.lang-row:last-child {
  margin-bottom: 0;
}
.lang-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 24px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
}
.text-input {
  flex: 1;
  min-width: 0;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.text-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.primary-btn:hover,
.primary-btn:focus,
.primary-btn:active {
  background: #017a48 !important;
  color: #fff;
}
@media (max-width: 767px) {
  .label-grid {
    grid-template-columns: 1fr;
  }
  .primary-btn {
    width: 100%;
  }
}
</style>
